module.exports = __webpack_public_path__ + "media/images/icons/ea-b3c3402d5c4783d0c490b5c31c4cb660.svg";